// extracted by mini-css-extract-plugin
export default {"mainPreloader":"mainPreloader_mainPreloader__fRtTJ","container":"mainPreloader_container__jtz49"};